import jQuery from 'jquery';

export default function myAdmin() {
	window.location.reload();
	jQuery.Animation = null;
}
